/**
 * FUNCTIONS RELATED FILTERS (IN CLP, PLP PAGES) START
 */

/* filter slidedown and slideup function */
window.filterbar = function() {
    $('.wcs-filter-bar > label').off('click').on('click', function() {
        $('.wcs-filter-link[data-type="wcs-frame-sunglass-filter"]').trigger('click');
    });
    $('#filterbarContainer > label').off('click').on('click', function() {
        $('.wcs-filter-link[data-type="wcs-frame-sunglass-filter"]').trigger('click');
    });
    toggleSortbyDropdownStatus();
};

/* filter panel positioning */
window.position_filterpannel = function() {
    if ($('.wcs-filter-type').length < 1) {
        $('.wcs-filter-container').css({
            'top': '',
            'margin-bottom': ''
        });
    } else {
        var filter_ht = $('.wcs-filter-type').height();
        $('.wcs-filter-container').css({
            'top': -filter_ht + 'px',
            'margin-bottom': -filter_ht + 'px'
        });
    }
};

//created for redesign Search by image page
//07-05-2020
function OpenCloseFilterItems() {
  var activeClass = 'item-open';

  jQuery('.filter-item-opener').on('click', function () {
    var clickedItem = jQuery(this),
      filterList = clickedItem.next();

    if(clickedItem.hasClass(activeClass)) {
      clickedItem.removeClass(activeClass);
      filterList.css('height', 0);
    }else {
      clickedItem.addClass(activeClass);
      filterList.css('height', 'auto');
    }
  });
}

window.open_filter = function() {
    $('.wcs-filter-link').off("click").on("click", function(e) {
        e.preventDefault();
        if ($(this).hasClass('wcs-active')) {
            $('body').removeClass('opened');
            $('.wcs-filter-container .wcs-close-btn').trigger('click');
            $('#wcs-sort-display .wcs-custom-dropdown-select').removeClass('disabled-sort-by');
            $('#wcs-sort-display .wcs-custom-dropdown-select input').removeClass('disabled-sort-by');

        } else {
            position_filterpannel();
          $('body').addClass('opened');
            var filter_class = $(this).attr('data-type');
            $('.wcs-filter-link .wcs-down_arrow').hide();
            $('#wcs-sort-display .wcs-custom-dropdown-select').addClass('disabled-sort-by');
            $('#wcs-sort-display .wcs-custom-dropdown-select input').addClass('disabled-sort-by');
            $('#wcs-sort-display #wcs-sort-wrapper1').addClass('wcs-hide');
            if ($('.wcs-filter-inner-container > div').is(':visible')) {
                $(this).find('.wcs-down_arrow').css('top', '8px').css('display', 'block');
                $('.wcs-filter-inner-container > div').hide();
                $('.wcs-filter-link').removeClass('wcs-active');
                $(this).addClass('wcs-active');

                if (filter_class == 'wcs-frame-shape-filter') {
                    $('.wcs-filter-inner-container').find('.wcs-frame-shape-model').show();
                } else if (filter_class == 'wcs-frame-models-filter') {
                    $('.wcs-filter-inner-container').find('.wcs-model-specials').show();
                } else if (filter_class == 'wcs-frame-sunglass-filter') {
                    if($('#country').val()=="MX"){
                      $('.wcs-sunglass-details .wcs-omega ul:first').css("text-transform","none");
                    }
                    $('.wcs-filter-inner-container').find('.wcs-sunglass-details').show();
                } else if (filter_class == 'wcs-frame-optics-filter') {
                    $('.wcs-filter-inner-container').find('.wcs-optics-details').show();
                }
            } else {
                $(this).find('.wcs-down_arrow').animate({
                    top: 8
                }, 200).css('display', 'block');
                $('.wcs-filter-inner-container > div').hide();
                $('.wcs-filter-link').removeClass('wcs-active');
                $(this).addClass('wcs-active');

                if (filter_class == 'wcs-frame-shape-filter') {
                    $('.wcs-filter-inner-container .wcs-frame-shape-model').slideDown('fast');
                } else if (filter_class == 'wcs-frame-models-filter') {
                    $('.wcs-filter-inner-container').find('.wcs-model-specials').slideDown('fast');
                } else if (filter_class == 'wcs-frame-sunglass-filter') {
                    if($('#country').val()=="MX"){
                      $('.wcs-sunglass-details .wcs-omega ul:first').css("text-transform","none");
                    }
                    $('.wcs-filter-inner-container').find('.wcs-sunglass-details').slideDown('fast');
                } else if (filter_class == 'wcs-frame-optics-filter') {
                    $('.wcs-filter-inner-container').find('.wcs-optics-details').slideDown('fast');
                }
            }
        }
    });
  OpenCloseFilterItems();
};

window.close_filter = function() {
    $('.wcs-filter-container .wcs-close-btn').off("click").on("click", function() {
        $('.wcs-filter-inner-container > div').slideUp('fast');
        $('.wcs-filter-link').removeClass('wcs-active').find('.wcs-down_arrow').animate({
            top: 0
        }, 100);

        toggleSortbyDropdownStatus();
    });
};

window.close_filter_outside = function() {
    $("#plp, #search").mouseup(function(e) {
    	var container = $("#FrameShape");
        var head = $("#filterByDivArea");

        if($('.wcs-sunglass-details').is(':visible') === true || $('.wcs-frame-shape-model').is(':visible') === true) {

	        if (!container.is(e.target) && container.has(e.target).length === 0 && !head.is(e.target) && head.has(e.target).length === 0)
	        {
	            $('.wcs-filter-container .wcs-close-btn').trigger('click');
	        }

        }
    });
};

window.filter_frame = function() {
    $('.wcs-filter-frame .wcs-frame-icon-wrap').off("click").on("click", function() {
        if (!$(this).parent().hasClass('disabled')) {
            $(this).parent().addClass('wcs-check').find('.wcs-filter-check').trigger('click');
        }
    });
};

window.filter_color = function() {
    $('.wcs-color-icon').off("click").on("click", function(e) {
        e.preventDefault();
        if (!$(this).hasClass('wcs-color-unavailable')) {
            if ($(this).hasClass('wcs-added')) {
                $(this).removeClass('wcs-added');
            } else {
                $(this).addClass('wcs-added');
            }
        }
    });
};

window.toggleSortbyDropdownStatus = function() {
    if ($(".wcs-filter-link").hasClass('wcs-active')) {
        $('#wcs-sort-display .wcs-custom-dropdown-select').addClass('disabled-sort-by');
        $('#wcs-sort-display .wcs-custom-dropdown-select input').addClass('disabled-sort-by');
        $('#wcs-sort-display #wcs-sort-wrapper1').addClass('wcs-hide');
    }else{
        $('#wcs-sort-display .wcs-custom-dropdown-select').removeClass('disabled-sort-by');
        $('#wcs-sort-display .wcs-custom-dropdown-select input').removeClass('disabled-sort-by');
    }
};
/* ------------------------------------------------------------------------
	FUNCTIONS RELATED FILTERS (IN CLP, PLP PAGES) ENDS
	--------------------------------------------------------------------------*/
